namespace $.$$ {

	type $shm_hitalama_tabulator_instance = {
		initialized: boolean
		destroy(): void
		setColumns( columns: readonly any[] ): void
		replaceData( data: readonly any[] ): void
		redraw( force?: boolean ): void
		on( event: string, handler: ( arg: any )=> void ): void
	}

	export class $shm_hitalama_tabulator extends $.$shm_hitalama_tabulator {

		table_current: null | $shm_hitalama_tabulator_instance = null
		table_observer: null | ResizeObserver = null

		@ $mol_mem
		style_loaded() {
			const doc = this.$.$mol_dom_context.document
			const id = 'hitalama_tabulator_css'
			const theme_id = 'hitalama_tabulator_theme_css'

			let link = doc.getElementById( id )
			if( !link ) {
				link = doc.createElement( 'link' )
				link.id = id
				doc.head.appendChild( link )
			}

			link.setAttribute( 'rel', 'stylesheet' )
			link.setAttribute( 'href', 'https://fastly.jsdelivr.net/npm/tabulator-tables@6.3.1/dist/css/tabulator.min.css' )

			let style = doc.getElementById( theme_id )
			if( !style ) {
				style = doc.createElement( 'style' )
				style.id = theme_id
			}

			style.textContent = `
[shm_hitalama_tabulator].tabulator {
	background: var(--hitalama_tabulator_background) !important;
	border-style: none !important;
	color: var(--hitalama_tabulator_text) !important;
	font-family: inherit !important;
	font-size: inherit !important;
}
[shm_hitalama_tabulator] .tabulator-header,
[shm_hitalama_tabulator] .tabulator-header .tabulator-col,
[shm_hitalama_tabulator] .tabulator-col-resize-handle {
	background: var(--mol_theme_card) !important;
	border-color: var(--hitalama_tabulator_line) !important;
	color: var(--hitalama_tabulator_text) !important;
}
[shm_hitalama_tabulator] .tabulator-header,
[shm_hitalama_tabulator] .tabulator-header .tabulator-header-contents,
[shm_hitalama_tabulator] .tabulator-header .tabulator-headers,
[shm_hitalama_tabulator] .tabulator-header .tabulator-col {
	box-sizing: border-box !important;
	height: var(--hitalama_tabulator_header_height) !important;
	min-height: var(--hitalama_tabulator_header_height) !important;
	max-height: var(--hitalama_tabulator_header_height) !important;
}
[shm_hitalama_tabulator] .tabulator-header .tabulator-col-resize-handle {
	box-sizing: border-box !important;
	height: var(--hitalama_tabulator_header_height) !important;
	min-height: 0 !important;
	max-height: var(--hitalama_tabulator_header_height) !important;
	top: 0 !important;
	bottom: auto !important;
}
[shm_hitalama_tabulator] .tabulator-header .tabulator-col .tabulator-col-content {
	box-sizing: border-box !important;
	display: flex !important;
	flex-direction: column !important;
	gap: .125em !important;
	height: 100% !important;
	justify-content: center !important;
	padding: .25em .375em !important;
}
[shm_hitalama_tabulator] .tabulator-header .tabulator-col .tabulator-col-title {
	line-height: 1.25 !important;
	min-height: 1.25em !important;
}
[shm_hitalama_tabulator] .tabulator-header .tabulator-col .tabulator-header-filter {
	margin-top: 0 !important;
}
[shm_hitalama_tabulator] .tabulator-header .tabulator-col .tabulator-header-filter input {
	box-sizing: border-box !important;
	font: inherit !important;
	height: 1.75em !important;
	min-height: 1.75em !important;
	padding: .125em .25em !important;
}
[shm_hitalama_tabulator] .tabulator-tableholder,
[shm_hitalama_tabulator] .tabulator-table,
[shm_hitalama_tabulator] .tabulator-row {
	background: var(--hitalama_tabulator_background) !important;
	color: var(--hitalama_tabulator_text) !important;
}
[shm_hitalama_tabulator].tabulator .tabulator-tableholder .tabulator-table .tabulator-row,
[shm_hitalama_tabulator].tabulator .tabulator-tableholder .tabulator-table .tabulator-row.tabulator-row-odd {
	background: var(--hitalama_tabulator_background) !important;
	color: var(--hitalama_tabulator_text) !important;
}
[shm_hitalama_tabulator].tabulator .tabulator-tableholder .tabulator-table .tabulator-row.tabulator-row-even {
	background: var(--hitalama_tabulator_stripe) !important;
	color: var(--hitalama_tabulator_text) !important;
}
[shm_hitalama_tabulator].tabulator .tabulator-tableholder .tabulator-table .tabulator-row.tabulator-selectable:hover {
	background: var(--hitalama_tabulator_hover) !important;
}
[shm_hitalama_tabulator] .tabulator-row .tabulator-cell {
	background: transparent !important;
	border-color: var(--hitalama_tabulator_line) !important;
	color: var(--hitalama_tabulator_text) !important;
}
[shm_hitalama_tabulator] .tabulator-placeholder {
	color: var(--hitalama_tabulator_shade) !important;
}
[shm_hitalama_tabulator] .tabulator-header-filter input,
[shm_hitalama_tabulator] .tabulator-page {
	border-color: var(--hitalama_tabulator_line) !important;
	color: var(--hitalama_tabulator_text) !important;
}
[shm_hitalama_tabulator] .tabulator-header-filter input {
	background: var(--mol_theme_back) !important;
}
[shm_hitalama_tabulator] .tabulator-page {
	background: var(--hitalama_tabulator_input) !important;
}
[shm_hitalama_tabulator] .tabulator-footer {
	background: var(--hitalama_tabulator_card) !important;
	border-color: var(--hitalama_tabulator_line) !important;
	color: var(--hitalama_tabulator_text) !important;
}
`

			doc.head.appendChild( style )

			return null
		}

		@ $mol_mem
		Tabulator() {
			return this.$.$mol_import.script( 'https://fastly.jsdelivr.net/npm/tabulator-tables@6.3.1/dist/js/tabulator.min.js' ).Tabulator
		}

		@ $mol_mem
		lights() {
			return this.$.$mol_lights()
		}

		style() {
			const lights = this.lights()
			return {
				... super.style(),
				backgroundColor: 'var(--hitalama_tabulator_background)',
				color: 'var(--hitalama_tabulator_text)',
				fontSize: 'inherit',
				'--hitalama_tabulator_background': 'transparent',
				'--hitalama_tabulator_card': lights ? '#f6f7f9' : '#202329',
				'--hitalama_tabulator_header_height': '3.5em',
				'--hitalama_tabulator_stripe': lights ? 'rgba( 27, 39, 56, .025 )' : 'rgba( 238, 242, 248, .035 )',
				'--hitalama_tabulator_hover': lights ? 'rgba( 36, 104, 214, .09 )' : 'rgba( 106, 164, 255, .16 )',
				'--hitalama_tabulator_text': 'var(--mol_theme_text)',
				'--hitalama_tabulator_shade': lights ? '#6d7480' : '#a8b0bc',
				'--hitalama_tabulator_line': lights ? '#d7dce3' : '#3b414a',
				'--hitalama_tabulator_input': lights ? '#ffffff' : '#171a1f',
			} as any
		}

		attr() {
			return {
				... super.attr(),
				shm_hitalama_tabulator: true,
				'data-hitalama-tabulator-stamp': this.sync_stamp(),
			}
		}

		@ $mol_mem
		sync_stamp() {
			const source = JSON.stringify({
				columns: this.columns(),
				data: this.data(),
				options: this.options(),
			})

			let hash = 0
			for( let index = 0; index < source.length; ++ index ) {
				hash = ( ( hash << 5 ) - hash + source.charCodeAt( index ) ) | 0
			}

			return String( hash )
		}

		@ $mol_mem
		table() {
			this.style_loaded()
			const Table = this.Tabulator()
			const options_raw = this.options() ?? {}
			const { cellEdited, ... options } = options_raw
			const columns = $mol_wire_probe( ()=> this.columns(), [] ) ?? []
			const data = $mol_wire_probe( ()=> this.data(), [] ) ?? []

			this.table_observer?.disconnect()
			this.table_current?.destroy()
			this.table_built( false )

			const node = this.dom_node()
			const table = new Table( node, {
				height: '100%',
				layout: 'fitDataStretch',
				movableColumns: true,
				resizableColumnFit: true,
				pagination: false,
				... options,
				debugInitialization: false,
				tableBuilt: ()=> {
					options.tableBuilt?.()
					this.table_built( true )
				},
				columns,
				data,
			} ) as $shm_hitalama_tabulator_instance

			if( typeof cellEdited === 'function' ) {
				table.on( 'cellEdited', cellEdited )
			}

			const observer = new ResizeObserver( ()=> {
				if( this.table_current !== table ) return
				if( !node.isConnected ) return
				if( !( table as any ).element?.isConnected ) return
				this.table_redraw( table )
			} )
			observer.observe( node )
			this.table_current = table
			this.table_observer = observer

			return table
		}

		@ $mol_mem
		table_built( next?: boolean ) {
			return next ?? false
		}

		dom_tree( next?: Element ) {
			const node = super.dom_tree( next )
			this.table_apply()
			return node
		}

		@ $mol_mem
		table_apply() {
			this.sync_stamp()
			const table = this.table()
			if( !this.table_built() ) return null
			if( !table.initialized ) return null

			this.table_sync( table )
			return null
		}

		table_sync( table: $shm_hitalama_tabulator_instance ) {
			if( this.table_current !== table ) return
			if( !this.dom_node().isConnected ) return
			if( !( table as any ).element?.isConnected ) return
			table.setColumns( this.columns() )
			table.replaceData( this.data() )
			this.table_redraw( table )
		}

		table_redraw( table: $shm_hitalama_tabulator_instance ) {
			try {
				table.redraw( true )
			} catch( error: any ) {
				if( String( error?.message ?? error ).includes( 'offsetWidth' ) ) return
				throw error
			}
		}

	}

}
